'use client';
import React from 'react';

import CustomListPage from '@/components/page-components/custom-list-page/custom-list-page';
// import { Seo } from '@/components/seo/seo';
import {
  createCategoryCardArray,
  createServiceSubCategoryCardArray,
} from '@/helpers/custom-list-page/custom-list-page-helpers';
import useGetMobileAppWebViewHeader from '@/hooks/use-get-mobile-app-web-view';
import { ILibraryServiceType } from '@/lib/fragments/libraryServiceType';
import { IMeetingplacePageHomeMinifiedExtendedLogo } from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageServiceList } from '@/lib/fragments/meetingPlacePageServiceList';
import { PageContext } from '../../../../page-context.interface';
import { useTenantConfig } from '@/providers/ConfigProvider';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageNewServiceListProps {
  metaData: any;
  serviceListPageData?: {
    meetingPlacePageServiceList: IMeetingPlacePageServiceList;
    meetingPlacePageHomeCollection: IMeetingplacePageHomeMinifiedExtendedLogo;
  };
  node_locale: string;
  urlSubdirectory: string | null;
  preview: boolean;
  initialPage?: number;
}
const MeetingPlacePageNewServiceList = ({
  metaData,
  serviceListPageData,
  node_locale,
  urlSubdirectory,
  preview,
  initialPage,
}: MeetingPlacePageNewServiceListProps) => {
  const config = useTenantConfig();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';

  const page = serviceListPageData?.meetingPlacePageServiceList;
  const homepage = serviceListPageData?.meetingPlacePageHomeCollection;

  const services = page?.servicesCollection?.items?.filter(Boolean) ?? [];

  const serviceTypeIdsFromServices = services?.map(
    (service) => service?.serviceType?.sys?.id,
  );
  const serviceCategories =
    page?.serviceCategoryCollection?.items?.filter(Boolean) || [];
  const reqCategories = serviceCategories
    ?.map((catg) => {
      // Filter the subcategories for each category
      const filteredSubCategories =
        catg?.subCategoriesCollection?.items
          ?.filter(Boolean)
          ?.filter((subCat) => {
            return serviceTypeIdsFromServices.includes(subCat?.sys?.id);
          }) || [];

      // Return the category with the filtered subcategories
      return {
        ...catg,
        subCategories: filteredSubCategories,
      };
    })
    .filter((catg) => catg.subCategories?.length > 0);
  // // category Card List
  const categoryCardList = createCategoryCardArray(reqCategories);
  const subCategoriesFromServiceCategories =
    reqCategories?.reduce<ILibraryServiceType[]>((acc, item) => {
      if (!item.isItAllCategories && item.subCategories) {
        item?.subCategories?.forEach((subCat) => {
          if (serviceTypeIdsFromServices.includes(subCat?.sys?.id)) {
            acc.push(subCat);
          }
        });
      }
      return acc;
    }, []) || [];

  const subCategoryCardList = [...subCategoriesFromServiceCategories];

  // sub category card list
  const subCategoryList = createServiceSubCategoryCardArray(
    subCategoryCardList,
    services,
    urlSubdirectory,
    prefix,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {/* ✅ GTM PAGE VIEW */}
      <GtmPageView
        homepage={homepage}
        language={node_locale}
        pageTitle={page?.name ?? ''}
      />

      <CustomListPage
        categoryList={categoryCardList}
        subCategoryList={subCategoryList}
        pageName={page?.name ?? ''}
        pageDescription={page?.description}
        pageSlug={page?.slug ?? ''}
        node_locale={node_locale}
        // location={location}
        breadcrumbs={[page?.name ?? '']}
        homeText={homepage?.breadcrumbHomeText ?? ''}
        tileColClass="grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
        listType="service"
        isWebView={isWebView}
        categoryText={page?.serviceCategoryName || ''}
        initialPage={initialPage ?? 1}
      />
    </>
  );
};

export default MeetingPlacePageNewServiceList;
